import { Comment } from 'component/comment';
import { CLICK, demoFile, extend, feature, POPUP, story, WITHIN } from 'system/demo';

import { PinReplyFeature } from '../pin-reply';

demoFile('feature/question/pin-reply', {
    designUrl:
        'https://www.figma.com/design/Jt0Nc37N6PP5bpoSDOhxGU/Ask-Me-Anything---Topic-of-the-Moment---Testing?node-id=1375-4021&m=dev',
});

extend(
    'Comment',
    'Pin Reply',
    Comment,
    {
        structureKey: 'question',
        features: ['pin_reply'],
        args: { commentKey: 'a' },
        state: {
            roles: ['Owner'],
            collections: {
                comment: [
                    { key: 'a', from: 'b', text: 'I like cats' },
                    { key: 'c', from: 'c', replyTo: 'a', text: 'Why do you like cats?' },
                    { key: 'd', from: 'd', replyTo: 'a', text: 'I like dogs' },
                ],
            },
            globals: { pinned_replies: { c: true } },
        },
    },
    [
        story('Unpin', [CLICK('admin-c'), POPUP(CLICK('Pinned'))]),
        story('Pin other', [
            CLICK('admin-c'),
            POPUP(CLICK('Pinned')),
            CLICK('toggle-replies'),
            CLICK('admin-d'),
            POPUP(CLICK('Pin')),
            CLICK('toggle-replies'),
        ]),
    ],
);
